
export default function PrivacyPage() {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #dc2626 0%, #ffffff 50%, #1e40af 100%)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
      padding: '40px 16px',
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
        maxWidth: '800px',
        width: '100%',
        padding: '48px',
        color: '#1f2937',
        lineHeight: '1.7',
      }}>
        <div style={{ marginBottom: '32px' }}>
          <h1 style={{ fontSize: '28px', fontWeight: '700', color: '#111827', marginBottom: '8px' }}>
            Privacy Policy
          </h1>
          <p style={{ color: '#6b7280', fontSize: '14px' }}>Last updated: April 14, 2026</p>
        </div>

        <section style={{ marginBottom: '28px' }}>
          <h2 style={{ fontSize: '18px', fontWeight: '600', color: '#111827', marginBottom: '10px' }}>
            1. Introduction
          </h2>
          <p>
            TravelFlow ("we," "our," or "us") is a business travel companion application that helps travelers
            manage trips, track flights, and discover dining and services near their destination. This Privacy
            Policy describes how we collect, use, and protect your personal information when you use TravelFlow.
          </p>
        </section>

        <section style={{ marginBottom: '28px' }}>
          <h2 style={{ fontSize: '18px', fontWeight: '600', color: '#111827', marginBottom: '10px' }}>
            2. Information We Collect
          </h2>
          <p style={{ marginBottom: '10px' }}>We collect the following categories of information:</p>
          <ul style={{ paddingLeft: '20px', marginBottom: '10px' }}>
            <li><strong>Account information:</strong> Name, email address, and password (managed via AWS Cognito).</li>
            <li><strong>Trip data:</strong> Flight details, hotel information, travel dates, destination cities, and restaurant and hotel reservations made through the app.</li>
            <li><strong>Profile preferences:</strong> Dining preferences, notification settings, and communication preferences.</li>
            <li><strong>Phone number:</strong> Collected only if you opt in to SMS flight alerts.</li>
            <li><strong>Usage data:</strong> Feature interactions and in-app activity used to improve the service.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '28px' }}>
          <h2 style={{ fontSize: '18px', fontWeight: '600', color: '#111827', marginBottom: '10px' }}>
            3. How We Use Your Information
          </h2>
          <ul style={{ paddingLeft: '20px' }}>
            <li>To provide and operate the TravelFlow service</li>
            <li>To send flight status alerts and departure reminders via SMS (with your consent)</li>
            <li>To surface contextual dining and travel recommendations at your destination</li>
            <li>To improve our AI-powered trip suggestions</li>
            <li>To communicate important service updates</li>
          </ul>
        </section>

        <section style={{ marginBottom: '28px' }}>
          <h2 style={{ fontSize: '18px', fontWeight: '600', color: '#111827', marginBottom: '10px' }}>
            4. Third-Party Services
          </h2>
          <p style={{ marginBottom: '10px' }}>
            TravelFlow integrates with the following third-party services to deliver features. Each service
            has its own privacy policy that governs their data practices:
          </p>
          <ul style={{ paddingLeft: '20px' }}>
            <li><strong>AWS (Amazon Web Services):</strong> Cloud infrastructure, authentication (Cognito), and database storage (DynamoDB).</li>
            <li><strong>FlightAware:</strong> Real-time flight tracking data.</li>
            <li><strong>AWS SNS:</strong> SMS delivery for flight alerts (only if you opt in).</li>
            <li><strong>OpenTable:</strong> Restaurant availability and reservation data at your travel destination.</li>
            <li><strong>Hotel booking partners:</strong> Hotel availability and reservation data (coming soon).</li>
            <li><strong>Amazon Bedrock (AI):</strong> AI-powered travel recommendations. Queries are not used to train models.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '28px' }}>
          <h2 style={{ fontSize: '18px', fontWeight: '600', color: '#111827', marginBottom: '10px' }}>
            5. Data Sharing
          </h2>
          <p>
            We do not sell your personal information. We share data only with the third-party services listed
            above as necessary to operate TravelFlow, and with service providers who assist us in operating
            the platform under confidentiality obligations.
          </p>
        </section>

        <section style={{ marginBottom: '28px' }}>
          <h2 style={{ fontSize: '18px', fontWeight: '600', color: '#111827', marginBottom: '10px' }}>
            6. Data Retention
          </h2>
          <p>
            Trip data is retained for the duration of your account. You may delete individual trips within the
            app at any time. Account data is retained until you request account deletion by contacting us.
          </p>
        </section>

        <section style={{ marginBottom: '28px' }}>
          <h2 style={{ fontSize: '18px', fontWeight: '600', color: '#111827', marginBottom: '10px' }}>
            7. Your Rights
          </h2>
          <p style={{ marginBottom: '10px' }}>You have the right to:</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Access the personal information we hold about you</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your account and associated data</li>
            <li>Opt out of SMS notifications at any time from within the app</li>
          </ul>
          <p style={{ marginTop: '10px' }}>
            To exercise these rights, contact us at{' '}
            <a href="mailto:privacy@travelflow.link" style={{ color: '#dc2626' }}>privacy@travelflow.link</a>.
          </p>
        </section>

        <section style={{ marginBottom: '28px' }}>
          <h2 style={{ fontSize: '18px', fontWeight: '600', color: '#111827', marginBottom: '10px' }}>
            8. Security
          </h2>
          <p>
            We use industry-standard security practices including encrypted data transmission (HTTPS/TLS),
            AWS-managed authentication, and role-based access controls. No method of transmission or storage
            is 100% secure; we will notify you of any breach affecting your data as required by applicable law.
          </p>
        </section>

        <section style={{ marginBottom: '28px' }}>
          <h2 style={{ fontSize: '18px', fontWeight: '600', color: '#111827', marginBottom: '10px' }}>
            9. Children's Privacy
          </h2>
          <p>
            TravelFlow is intended for use by adults (18+) and business travelers. We do not knowingly collect
            information from children under 13.
          </p>
        </section>

        <section style={{ marginBottom: '28px' }}>
          <h2 style={{ fontSize: '18px', fontWeight: '600', color: '#111827', marginBottom: '10px' }}>
            10. Changes to This Policy
          </h2>
          <p>
            We may update this policy periodically. When we do, we will revise the "Last updated" date above.
            Continued use of TravelFlow after changes constitutes your acceptance of the updated policy.
          </p>
        </section>

        <section>
          <h2 style={{ fontSize: '18px', fontWeight: '600', color: '#111827', marginBottom: '10px' }}>
            11. Contact Us
          </h2>
          <p>
            For privacy-related questions or requests, contact us at:{' '}
            <a href="mailto:privacy@travelflow.link" style={{ color: '#dc2626' }}>privacy@travelflow.link</a>
          </p>
        </section>

        <div style={{
          marginTop: '40px',
          paddingTop: '24px',
          borderTop: '1px solid #e5e7eb',
          textAlign: 'center',
        }}>
          <a
            href="/"
            style={{
              display: 'inline-block',
              background: 'linear-gradient(135deg, #dc2626, #1e40af)',
              color: 'white',
              padding: '10px 24px',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '14px',
            }}
          >
            Back to TravelFlow
          </a>
        </div>
      </div>
    </div>
  );
}
